// src/components/Calendar/_availabilityShared.js

import {
  getFirestore,
  doc,
  getDoc,
  setDoc,
  deleteDoc,
  serverTimestamp,
  collection,
  addDoc,
} from "firebase/firestore";

// The backend packages this same helper during the Functions build.
import {expandAvailability} from '../../shared/availability';

export function expandRecurringAvailabilities(records, weekStart, weekEnd) {
  // Existing callers supply an inclusive end; the shared engine is half-open.
  return expandAvailability(records, weekStart, new Date(+new Date(weekEnd) + 1));
}


/**
 * Copy the user's private personalAvailabilities to a public "share" doc.
 * If share=false, delete the share doc.
 */
export async function setAvailabilityShare({ userId, share, tz, personalAvailabilities }) {
  const db = getFirestore();
  const ref = doc(db, "availabilityShares", userId);

  if (!share) {
    await deleteDoc(ref).catch(() => {}); // ok if doesn't exist
    return;
  }
  await setDoc(ref, {
    share: true,
    tz: tz || null,
    updatedAt: serverTimestamp(),
    availabilities: Array.isArray(personalAvailabilities) ? personalAvailabilities : []
  }, { merge: true });
}

/** Read a player's public share doc (if it exists). */
export async function getAvailabilityShare(userId) {
  const db = getFirestore();
  const ref = doc(db, "availabilityShares", userId);
  const snap = await getDoc(ref);
  return snap.exists() ? snap.data() : null;
}

/**
 * Expand and import a player's (shared) availabilities into a team for a given week window.
 * Writes non-recurring instances into teams/{teamId}.availabilities (userId=username preserved).
 */
export async function importSharedAvailToTeam({ teamId, playerUserId, playerUsername, weekStart, weekEnd }) {
  const db = getFirestore();
  const ref = doc(db, "availabilityShares", playerUserId);
  const snap = await getDoc(ref);
  if (!snap.exists()) return 0;

  const shared = snap.data() || {};
  if (!shared.share || !Array.isArray(shared.availabilities)) return 0;

  // Reuse your expansion util
  const instances = expandRecurringAvailabilities(shared.availabilities, weekStart, weekEnd);
  if (!instances.length) return 0;

  const teamAvailCol = collection(db, "teams", teamId, "availabilities");

  for (const inst of instances) {
    const rec = {
      userId: playerUserId,
      username: playerUsername || "Player",
      startUTC: inst.startUTC,
      endUTC: inst.endUTC,
      repeat: "none",
      repeatEndDate: null,
      exceptions: [],
      overrides: {},
      scope: "imported-from-LFG-share",
      createdAt: Date.now(),
    };

    await addDoc(teamAvailCol, rec);
  }

  return instances.length;
}